import { isBuildActivity, siteTermOf, t, type Mail, type SiteTerm } from '@procumi/shared';

/**
 * Domeniul firmei: cuvântul ei pentru șantier („șantier”, „locație”, „fermă”,
 * „punct de lucru”, „proiect”; shared/siteTerms.ts) și dacă e din construcții.
 * O singură firmă pe sesiune, deci le ține App la fiecare desenare, ca
 * `market.ts` cu țara.
 *
 * Textele din ecrane rămân scrise cu „șantier” și trec prin `sw()`: pentru
 * șantier ies neatinse, pentru celelalte cu cuvântul firmei. Un text nou cu
 * „șantier” sau „antemăsurătoare” trece și el prin `sw()`.
 */
let term: SiteTerm = siteTermOf(null);
let build = true;

export function setDomain(company: { siteTerm: string; activity: string }): void {
  term = siteTermOf(company.siteTerm);
  // înainte de 27 oct lista de domenii era doar de construcții: „Altceva” de atunci
  // e tot o firmă de construcții, și a rămas pe „șantier”
  build = term.id === 'santier' || isBuildActivity(company.activity);
  // fiecare domeniu are culoarea lui de accent (styles/v3.css)
  if (typeof document !== 'undefined')
    document.documentElement.dataset.industry = industryTheme(company.activity, build);
}

/** Tema de culoare a domeniului: build, horeca, make, trade, agri, office. */
export function industryTheme(activity: string, isBuild: boolean): string {
  if (isBuild) return 'build';
  if (activity === 'horeca') return 'horeca';
  if (activity === 'manufacturing') return 'make';
  if (activity === 'trade' || activity === 'logistics') return 'trade';
  if (activity === 'agri') return 'agri';
  return 'office';
}

export const siteTerm = (): SiteTerm => term;

/**
 * Firma din construcții (după domeniul ales; fără răspuns, tot construcții):
 * antemăsurătoarea, chestionarul de cofraje, chiria pe zile, desenul cu macara și
 * exemplele cu blocuri sunt doar pentru ea. Celelalte domenii nu le văd.
 */
export const isBuild = (): boolean => build;

/** Textul în limba omului, cu cuvântul firmei (vezi `t` din shared/i18n.ts). */
export const sw = (text: string): string => t(text);

/** Mailul către furnizor, cum îl vede omul înainte să plece: cu cuvântul firmei. */
export const swMail = (m: Mail): Mail => ({
  ...m,
  subject: sw(m.subject),
  body: sw(m.body),
});
